import { OccConfig, OccEndpoints } from '@spartacus/core';

export const checkoutApiConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        createQuote: 'users/${userId}/quotes/create',
        placeNewOrder: 'users/${userId}/place-order',
        editOrder: 'users/${userId}/orders/${orderCode}/flu-order-edit',
        placeExpressOrder: 'users/${userId}/place-express-delivery-order',
      } as OccEndpoints,
    },
  },
};
